define((require) => {
    "use strict";

    var LinkWidgetModel = require("shared/ui/experience/widgets/linkWidget/LinkWidgetModel");

    /**
     * @class {LinkWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return LinkWidgetModel.mixin("LinkWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function() {
            return this.get("action") && this.get("action").get("url")
                ? `Link: ${this.get("action").get("url")}`
                : null;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/linkWidget/LinkWidgetModelEditorMixin.js